export default "__VITE_ASSET__CmHMkaGf__"